import axios from "axios";
import { authenticatedApiConfig, generateURL } from "./BaseApiService";
export class IASHealthCheckService {
    constructor(authenticationProvider, environment) {
        this.authenticationProvider = authenticationProvider;
        this.environment = environment;
    }
    async runHealthCheck() {
        const response = await axios.post(generateURL(this.environment.API_BASE_URL, "/ias-healthcheck/run"), {}, authenticatedApiConfig(this.authenticationProvider));
        return response.data;
    }
    async getLatestHealthChecks() {
        var _a;
        const response = await axios.get(generateURL(this.environment.API_BASE_URL, "/ias-healthcheck/latest"), authenticatedApiConfig(this.authenticationProvider));
        return (_a = response.data) !== null && _a !== void 0 ? _a : [];
    }
}
